import { xlCol, xlColq } from "../../../common/constants"
const commonPdfColSx = {
  textColor: [0, 0, 0],
  fontSize: 16,
  cellPadding: 6,
  font: 'Roboto',
  fontStyle: 'normal',
  valign: 'top',
  minCellHeight: 36,
};
export const viewColumns = [
  { headerName: 'SN', exportHead: "SN", field: 'sn', xlCol: xlCol, pdfColSx: { ...commonPdfColSx, halign: 'left' }, width: "20px", align: 'left', },
  { headerName: 'Branch\nName', exportHead: "Branch Name", field: 'BranchName', xlCol: xlCol, pdfColSx: { ...commonPdfColSx, halign: 'left' }, width: "140px", align: 'left' , },
  { headerName: 'Transaction\nDate', exportHead: "Transaction Date", field: 'TranDate', xlCol: xlCol, pdfColSx: { ...commonPdfColSx, halign: 'left' }, width: "60px", align: 'left',  },
  { headerName: 'Opening\nBalance', exportHead: "Opening Balance", field: 'openingblnc', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, width: "100px", align: 'right' , },
  { headerName: 'Branch\nCollection', exportHead: "Branch Collection", field: 'BusCollectionAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, width: "80px", align: 'right' , },
  { headerName: 'Dispatch\nReg. Memo', exportHead: "Dispatch Reg. Memo", field: 'CargoCollectionAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, width: "80px", align: 'right' , },
  { headerName: 'Total\nReceivable', exportHead: "Total Receivable", field: 'TotalAmount', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, width: "80px", align: 'right',  },
  { headerName: 'Received\nCash Amt.', exportHead: "Received Cash Amt", field: 'OldReceivedAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, width: "80px", align: 'right',  },
  { headerName: 'Received\nOnline Amt.', exportHead: "Received Online Amt", field: 'OldReceivedBankAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, width: "80px", align: 'right',  },
  { headerName: 'Closing\nBalance', exportHead: "Closing Balance", field: 'ClosingBalance', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, width: "80px", align: 'right' , },
  { headerName: 'Remarks', exportHead: "Remarks", field: 'OldRemarks', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'left' }, width: "80px", align: 'right',  },
  { headerName: 'Modified\nBy User', exportHead: "Modified By User", field: 'UserName', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'left' }, width: "100px", align: 'right' },
  { headerName: 'Action', exportHead: "Action", field: 'Action', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'left' }, width: "80px", align: 'right' },
]
export const columnsHeader = [
  { headerName: 'Company', field: 'company', xlCol: xlCol, minWidth: "80px", colSpan: 3 },
  { headerName: 'City', field: 'city', xlCol: xlColq, span: 2, colSpan: 3 },
  { headerName: 'Branch', field: 'branch', xlCol: xlColq, span: 2, colSpan: 3 },
]
export const baseStyle = {
  valign: 'middle',
  font: 'Roboto',
  fontStyle: 'normal',
  cellPadding: 12,
  minCellHeight: 36,
  halign: 'left',
  textColor: [0, 0, 0],
}